import {Injectable} from '@angular/core';
import {ToastController} from "ionic-angular";


@Injectable()
export class NotificationProvider {

    constructor(public toastController: ToastController) {
    }

    private showToast(message, className) {
        let toast = this.toastController.create({
            message: message,
            duration: 2700,
            position: 'top',
            cssClass: 'toast-super toast-super-' + className
        });

        return toast.present();
    }

    public async showSuccessMessage(message) {
        return this.showToast(message, 'success');
    }

    public async showErrorMessage(message) {
        return this.showToast(message, 'error');
    }

    public async showInfoMessage(message) {
        return this.showToast(message, 'info');
    }
}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts